export const offerTypes = {
    FETCHING_MORE_OFFERS: "FETCHING_MORE_OFFERS",
    GET_FEATURED_OFFERS: "GET_FEATURED_OFFERS",
    GET_MOST_VIEWED_OFFERS: "GET_MOST_VIEWED_OFFERS",
    GET_OFFERS: "GET_OFFERS",
    NO_MORE_OFFERS: "NO_MORE_OFFERS",
    GET_OFFERS_CATEGORIES: "GET_OFFERS_CATEGORIES",
    GET_OFFER_DETAILS: "GET_OFFER_DETAILS",
    OFFER_ID_NOT_FOUND: "OFFER_ID_NOT_FOUND",
    SET_OFFER_CATEGORY: "SET_OFFER_CATEGORY",
    CLEAR_OFFER_DETAILS: "CLEAR_OFFER_DETAILS",
    CLEAR_OFFER_CATEGORY: "CLEAR_OFFER_CATEGORY",
    CLEAR_OFFER_LIST_AND_CATEGORIES: "CLEAR_OFFER_LIST_AND_CATEGORIES",
    CLEAR_OFFER_LIST: "CLEAR_OFFER_LIST",
    CLEAR_SHOW_MORE: "CLEAR_SHOW_MORE",
};